import MojitoPresentation from 'mojito/presentation';
const { FlexPane, Text, Button } = MojitoPresentation.Components;

const BetslipError = props => {
    const { mojitoTools, onOkClick, message } = props;
    const { config, stringResolver } = mojitoTools;

    return (
        <FlexPane config={config.container} class="ta-BetslipError">
            <Text config={config.errorText}>
                {message
                    ? message
                    : stringResolver.resolveAndFormatString(
                          '$BETSLIP_NOTIFICATIONS.MESSAGES.TECHNICAL_FAILURE',
                          undefined
                      )}
            </Text>
            <FlexPane config={config.okButtonContainer}>
                <Button config={config.okButton} onClick={onOkClick} class="ta-ErrorButton">
                    <Text config={config.okButtonText}>
                        {stringResolver.resolveAndFormatString('$BETSLIP.OK')}
                    </Text>
                </Button>
            </FlexPane>
        </FlexPane>
    );
};

export default BetslipError;
